import React from 'react';
import { Dialog } from '@material-ui/core';

import { ClientSummaryNode } from '../../generated/webapp_gql';
import { ReactComponent as IconClose } from '../../assets/svgs/icon-close.svg';
import { ReactComponent as IconTriangleWarning } from '../../assets/svgs/icon-triangle-warning.svg';

interface Props {
  isOpen: boolean;
  closeDialog: () => void;
  onRetry: () => void;
  onBackToEdit: () => void;
  membersToBulkMessage: ClientSummaryNode[];
}

export enum BulkMessageFailureModalTestID {
  BulkMessageFailureModalCloseButton = 'BulkMessageFailureModalCloseButton',
  BulkMessageFailureModalOnRetryButton = 'BulkMessageFailureModalOnRetryButton',
  BulkMessageFailureModalOnBackToEditButton = 'BulkMessageFailureModalOnBackToEditButton',
  BulkMessageFailureModalMembersContainer = 'BulkMessageFailureModalMembersContainer',
}

export const BulkMessageFailureModal: React.FC<Props> = ({
  closeDialog,
  isOpen,
  onBackToEdit,
  onRetry,
  membersToBulkMessage,
}) => {
  return (
    <Dialog open={isOpen} onClose={closeDialog} aria-labelledby="form-dialog-title" fullWidth>
      <div className="p-4 h-full relative">
        <div
          onClick={closeDialog}
          data-testid={BulkMessageFailureModalTestID.BulkMessageFailureModalCloseButton}
          className="bg-gray-300 hover:bg-gray-200 cursor-pointer rounded-full h-10 w-10 absolute top-4 right-4 flex justify-center items-center"
        >
          <IconClose className="w-3 h-3 text-gray-1000 fill-current stroke-current" />
        </div>
        <div />
        <div className="p-8 flex flex-col">
          <h1 className="font-bold text-black text-2xl mb-4">Failed to send to some users</h1>
          <p className="text-gray-700 text-sm">These users weren’t able to receive your message.</p>
          <div
            className="my-4 max-h-64 overflow-y-auto"
            data-testid={BulkMessageFailureModalTestID.BulkMessageFailureModalMembersContainer}
          >
            {membersToBulkMessage.map((person, i) => {
              return (
                <div className="flex flex-row items-center" key={`member_${i}`}>
                  {' '}
                  <IconTriangleWarning className="h-3 w-3 text-orange-500 fill-current stroke-current mx-3" />
                  <p className="text-orange-500 font-bold mr-4 text-sm">
                    {person.memberFirstName} {person.memberLastName}
                  </p>
                  <p className="text-gray-600 m-2 pr-3 border-r border-gray-400 text-sm">
                    {person.companyName}
                  </p>
                  <p className="text-gray-600 m-2 text-sm">{person.memberEmail}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex flex-row justify-end">
          <button
            data-testid={BulkMessageFailureModalTestID.BulkMessageFailureModalOnBackToEditButton}
            className="px-2 text-base mr-4 outline-none h-10 flex font-extrabold justify-center items-center text-blue-200 p-2 px-4 rounded border border-blue-200"
            onClick={onBackToEdit}
          >
            Back to Edit
          </button>
          <button
            data-testid={BulkMessageFailureModalTestID.BulkMessageFailureModalOnRetryButton}
            onClick={onRetry}
            className="px-12 outline-none h-10 flex font-extrabold justify-center items-center text-white p-2 px-4 rounded hover:shadow-md bg-blue-200"
          >
            Retry
          </button>
        </div>
      </div>
    </Dialog>
  );
};
